'use client';

import Head from '@/core/head';
import { Markdown, hocT, lang } from '@/helpers/translate';
import { getCanonicalUrl } from '@/helpers/router.js';
import { H1, Kicker, kicker } from '@/core/editorial';

export default hocT(({ t }) => {
  const langCurrent = lang();
  const canurls = getCanonicalUrl('privacy', langCurrent);
  return (
    <div className="bg-white">
      <Head>
        {canurls.map((cprops) => <link key={JSON.stringify(cprops)} {...cprops} />)}
      </Head>
      <section className="bg-white font-display">
        <div className="mx-auto max-w-[1240px] border-b border-was-ink/8 px-6 pb-12 pt-28 lg:px-8 lg:pb-16 lg:pt-36">
          <Kicker n="01">{kicker(langCurrent, 'legal', 0)}</Kicker>
          <h1 className={`mt-5 max-w-[820px] text-balance ${H1}`}>{t('privacy:title')}</h1>
        </div>
      </section>
      <section className="mx-auto max-w-[1240px] px-6 py-16 lg:px-8 lg:py-20">
        <div className="max-w-[820px] text-[15px] leading-7 privacy text-was-slate">
        <Markdown>
          {t('privacy:all')}
        </Markdown>
        </div>
      </section>
    </div>
  );
});
